document.addEventListener('DOMContentLoaded', function() {
  console.log('Antenna Selector: Script loaded');

  const answersAST = {};
  const baseProductUrlAST = 'https://www.5gboosters.com.au/collections/radio-cellular-antennas-mounts';

  const toolContainer = document.getElementById('antennaSelectorToolContainer');
  if (!toolContainer) {
    console.error('Antenna Selector: Container not found!');
    return;
  }
  console.log('Antenna Selector: Container found');

  const questionsAST = {
    q1AST: toolContainer.querySelector('#q1AST'),
    q2AST: toolContainer.querySelector('#q2AST'),
    q3AST: toolContainer.querySelector('#q3AST'),
    q4AST: toolContainer.querySelector('#q4AST'),
    q5AST: toolContainer.querySelector('#q5AST'),
    q6AST: toolContainer.querySelector('#q6AST'),
  };
  const recommendationAreaAST = toolContainer.querySelector('#recommendationAreaAST');
  const startOverButtonAST = toolContainer.querySelector('#startOverButtonAST');

  // Verify questions exist
  Object.entries(questionsAST).forEach(([key, element]) => {
    if (!element) console.warn(`Antenna Selector: ${key} not found`);
  });

  // Attach event listeners
  const optionButtons = toolContainer.querySelectorAll('.option-button');
  console.log(`Antenna Selector: Found ${optionButtons.length} option buttons`);
  optionButtons.forEach(button => {
    button.addEventListener('click', function() {
      console.log(`Antenna Selector: Clicked button with question=${this.dataset.question}, value=${this.dataset.value}`);
      const questionId = this.dataset.question;
      const value = this.dataset.value;
      answersAST[questionId] = value;

      toolContainer.querySelectorAll(`.option-button[data-question="${questionId}"]`).forEach(btn => {
        btn.classList.remove('selected');
      });
      this.classList.add('selected');

      questionsAST[questionId].querySelectorAll('button').forEach(btn => btn.disabled = true);
      handleNextStepAST(questionId);
    });
  });

  if (startOverButtonAST) {
    startOverButtonAST.addEventListener('click', function() {
      console.log('Antenna Selector: Start Over clicked');
      for (const key in answersAST) {
        delete answersAST[key];
      }
      Object.values(questionsAST).forEach((qElement, index) => {
        if (qElement) {
          qElement.classList.add('hidden-question');
          qElement.querySelectorAll('button').forEach(btn => {
            btn.classList.remove('selected');
            btn.disabled = false;
          });
          if (index === 0) {
            qElement.classList.remove('hidden-question');
          }
        }
      });
      if (recommendationAreaAST) recommendationAreaAST.classList.add('hidden-question');
    });
  } else {
    console.warn('Antenna Selector: Start Over button not found');
  }

  function showQuestionAST(questionId) {
    if (questionsAST[questionId]) {
      console.log(`Antenna Selector: Showing question ${questionId}`);
      questionsAST[questionId].classList.remove('hidden-question');
      questionsAST[questionId].scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      console.error(`Antenna Selector: Question ${questionId} not found`);
    }
  }

  function handleNextStepAST(currentQuestionId) {
    console.log(`Antenna Selector: Handling next step for ${currentQuestionId}`);
    if (currentQuestionId === 'q1AST') {
      showQuestionAST('q2AST'); // All options go to Signal Strength
    } else if (currentQuestionId === 'q2AST') {
      showQuestionAST('q3AST');
    } else if (currentQuestionId === 'q3AST') {
      if (answersAST.q3AST === 'modem') {
        showQuestionAST('q4AST');
      } else {
        showQuestionAST('q5AST');
      }
    } else if (currentQuestionId === 'q4AST') {
      showQuestionAST('q5AST');
    } else if (currentQuestionId === 'q5AST') {
      showQuestionAST('q6AST');
    } else if (currentQuestionId === 'q6AST') {
      getRecommendationAST();
    }
  }

  function getRecommendationAST() {
    console.log('Antenna Selector: Generating recommendation', answersAST);
    let recText = 'Based on your selections, we recommend consulting our full catalog or contacting us.';
    let recReason = 'Your specific needs might require a more detailed assessment.';
    let productLink = baseProductUrlAST;
    let searchQuery = [];

    const useType = answersAST.q1AST;
    const signal = answersAST.q2AST;
    const device = answersAST.q3AST;
    const mimo = answersAST.q4AST;
    const frequency = answersAST.q5AST;
    const mounting = answersAST.q6AST;

    if (useType === 'vehicle') {
      searchQuery.push('omni');
      if (device === 'modem' && mimo === 'yes_mimo') {
        recText = `MIMO Omni-directional Vehicle Antenna (${mounting === 'magnetic' ? 'Magnetic' : mounting === 'Permanent' ? 'Permanent' : 'Standard'} Mount)`;
        recReason = `Ideal for vehicles needing robust ${frequency === '5g' ? '5G' : '4G'} data with MIMO-capable modems. The ${mounting} mount suits your installation needs.`;
        searchQuery.push('mimo');
      } else {
        recText = `Omni-directional Vehicle Antenna (${mounting === 'magnetic' ? 'Magnetic' : mounting === 'Permanent' ? 'Permanent' : 'Standard'} Mount)`;
        recReason = `Best for all-around ${frequency === '5g' ? '5G' : '4G'} signal reception in vehicles. The ${mounting} mount is suitable for your setup.`;
      }
    } else if (useType === 'home_small_building') {
      if (signal === 'good_fair') {
        searchQuery.push('omni');
        if (device === 'modem' && mimo === 'yes_mimo') {
          recText = `MIMO Omni-directional Outdoor Antenna (${mounting === 'wall_pole' ? 'Wall/Pole' : 'Standard'} Mount)`;
          recReason = `Suitable for areas with decent ${frequency === '5g' ? '5G' : '4G'} signal from multiple directions, for MIMO modems. The ${mounting} mount fits your installation.`;
          searchQuery.push('mimo');
        } else {
          recText = `Omni-directional Outdoor Antenna (${mounting === 'wall_pole' ? 'Wall/Pole' : 'Standard'} Mount)`;
          recReason = `Ideal for locations with fair to good ${frequency === '5g' ? '5G' : '4G'} signal strength from various directions. The ${mounting} mount is appropriate.`;
        }
      } else if (signal === 'weak') {
        searchQuery.push('directional');
        if (device === 'modem' && mimo === 'yes_mimo') {
          recText = `MIMO Directional Antenna (Panel or LPDA, ${mounting === 'wall_pole' ? 'Wall/Pole' : 'Standard'} Mount)`;
          recReason = `Focuses ${frequency === '5g' ? '5G' : '4G'} signal capture towards the tower for MIMO modems in weaker signal areas. The ${mounting} mount suits your needs.`;
          searchQuery.push('mimo');
        } else {
          recText = `Directional Antenna (Panel or LPDA, ${mounting === 'wall_pole' ? 'Wall/Pole' : 'Standard'} Mount)`;
          recReason = `Targets the cell tower to boost weaker ${frequency === '5g' ? '5G' : '4G'} signals. The ${mounting} mount is ideal for fixed installations.`;
        }
      } else if (signal === 'very_weak') {
        searchQuery.push('high-gain-directional');
        if (device === 'modem' && mimo === 'yes_mimo') {
          recText = `High-Gain MIMO Directional Antenna (Dual Yagi or MIMO LPDA, ${mounting === 'wall_pole' ? 'Wall/Pole' : 'Standard'} Mount)`;
          recReason = `Essential for very weak ${frequency === '5g' ? '5G' : '4G'} signal areas with MIMO modems. Requires precise aiming. The ${mounting} mount fits your setup.`;
          searchQuery.push('mimo');
        } else {
          recText = `High-Gain Directional Antenna (Yagi or High-Gain LPDA, ${mounting === 'wall_pole' ? 'Wall/Pole' : 'Standard'} Mount)`;
          recReason = `The best choice for extremely weak ${frequency === '5g' ? '5G' : '4G'} signal areas. Needs careful aiming. The ${mounting} mount is suitable.`;
        }
      }
    } else if (useType === 'large_building') {
      searchQuery.push('high-gain-directional', 'lpda');
      recText = `High-Gain Directional Antenna (LPDA, ${mounting === 'wall_pole' ? 'Wall/Pole' : 'Standard'} Mount) + Consultation`;
      recReason = `Large buildings require a custom site survey for optimal ${frequency === '5g' ? '5G' : '4G'} coverage. A high-gain directional LPDA antenna is a typical starting point. Please contact us.`;
    } else if (useType === 'm2m_iot') {
      searchQuery.push('compact-omni');
      if (device === 'modem' && mimo === 'yes_mimo') {
        recText = `Compact MIMO Omni-directional Antenna (${mounting === 'magnetic' ? 'Magnetic' : mounting === 'Permanent' ? 'Permanent' : 'Standard'} Mount)`;
        recReason = `Suitable for M2M/IoT devices with MIMO capability needing reliable ${frequency === '5g' ? '5G' : '4G'} signal reception. The ${mounting} mount fits your setup.`;
        searchQuery.push('mimo');
      } else {
        recText = `Compact Omni-directional Antenna (${mounting === 'magnetic' ? 'Magnetic' : mounting === 'Permanent' ? 'Permanent' : 'Standard'} Mount)`;
        recReason = `Designed for M2M/IoT applications needing a small, durable ${frequency === '5g' ? '5G' : '4G'} antenna. The ${mounting} mount is appropriate.`;
      }
    }

    // Add frequency and mounting to search query
    searchQuery.push(frequency);
    if (mounting !== 'standard') {
      searchQuery.push(mounting);
    }

    // Construct search query URL
    productLink = `${baseProductUrlAST}?q=${encodeURIComponent(searchQuery.join('+'))}`;
    console.log(`Antenna Selector: Generated product link: ${productLink}`);

    if (recommendationAreaAST) {
      toolContainer.querySelector('#recommendationTextAST').textContent = recText;
      toolContainer.querySelector('#recommendationReasonAST').textContent = recReason;
      toolContainer.querySelector('#recommendationLinkAST').href = productLink;
      recommendationAreaAST.classList.remove('hidden-question');
      recommendationAreaAST.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      console.error('Antenna Selector: Recommendation area not found');
    }
  }

  if (questionsAST.q1AST) {
    questionsAST.q1AST.classList.remove('hidden-question');
    console.log('Antenna Selector: Initialized first question');
  } else {
    console.error('Antenna Selector: First question not found');
  }
});